import * as z from 'zod/mini';

const ParticipantSchema = z.object({
  index: z.number(),
  gender: z.nullable(z.string()),
  first_name: z.string(),
  last_name: z.string(),
  birth_date: z.string(),
  medical_info: z.nullable(z.string()),
  meal_preferences: z.nullable(z.string()),
  preferences: z.nullable(z.string()),
  passport_number: z.nullable(z.string()),
});

const packageInformation = {
  session_id: z.string(),
  main_booker: z.object({
    email: z.string(),
    phone_country_code: z.nullable(z.string()),
    phone: z.string(),
    phone_trip_country_code: z.nullable(z.string()),
    phone_trip: z.nullable(z.string()),
    passport_number: z.nullable(z.string()),
  }),
  address: z.object({
    street: z.string(),
    housenum: z.nullish(z.string()),
    address_line_2: z.nullish(z.string()),
    city: z.string(),
    state: z.nullish(z.string()),
    postal_code: z.string(),
    country: z.string(),
  }),
  participants: z.array(ParticipantSchema),
  room_assignments: z.array(z.object({
    participant_index: z.nullable(z.union([z.string(), z.number()])),
    order_session_room_type_id: z.number(),
  })),
  bike_rider_height: z.nullish(z.array(z.object({
    participant_index: z.nullable(z.union([z.string(), z.number()])),
    height_cm: z.nullable(z.union([z.string(), z.number()])),
  }))),
  promo_code: z.nullish(z.string()),
  agreement: z.coerce.boolean(),
  newsletter: z.coerce.boolean(),
  debug: z.nullish(z.array(z.any())),
};

export const PackageInformationRequestSchema = z.object(packageInformation);

export const PackageInformationResponseSchema = PackageInformationRequestSchema;

export const PackageInformationMutationRequestSchema = z.object({
  ...packageInformation,
  locale: z.string(),
});

export const PackageInformationMutationResponseSchema = z.object({
  message: z.string(),
});
